import { useRef } from 'react';
import { IonButton, IonContent } from '@ionic/react';
import ModalHeader from '../../components/modals/ModalHeader';
import ModalWrapper from '../../components/modals/ModalWrapper';
import DeliveryAddressForm, { HandleDeliveryFormRef } from './form/DeliveryAddressForm';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';
import { DeliveryAddressSchema } from './form/schema';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderMethodModalDataDeliveryData, setDeliveryData } from '../../../../store/slices/OrderMethodSlice';

const DeliveryAddressModal = ({ goBack }: Partial<IModal>) => {
  const formRef = useRef<HandleDeliveryFormRef>(null);
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:DeliveryAddress:DeliveryAddressModal' });
  const deliveryData = useSelector(selectOrderMethodModalDataDeliveryData);
  const dispatch = useDispatch();
  const onSubmitForm = (data: Required<DeliveryAddressSchema>): void => {
    dispatch(setDeliveryData(data));
    goBack();
  };

  return (
    <ModalWrapper className="mt-4">
      <ModalHeader
        title={t('title')}
        onBack={goBack}
        endSlot={
          <IonButton
            slot="end"
            type="button"
            fill="clear"
            className="min-h-none [&::part(native)]:p-0 m-0 [&::part(native)]:text-brand-primary [&::part(native)]:text-base"
            color="light"
            onClick={() => formRef.current.submit()}
          >
            {t('buttons.save')}
          </IonButton>
        }
      />
      <IonContent className="min-h-[75dvh]">
        <DeliveryAddressForm ref={formRef} onSubmit={onSubmitForm} defaultValues={deliveryData} />
      </IonContent>
    </ModalWrapper>
  );
};

export default DeliveryAddressModal;
